import { Card, Col, Row } from 'react-bootstrap';

import { ChangePasswordForm } from '@components/Forms';

export const UserChangePassword = () => (
  <Row>
    <Col md={12}>
      <Card>
        <Card.Header className="bg-didxl text-white text-center">
          Change Password
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={3} />
            <Col md={6}>
              <ChangePasswordForm />
            </Col>
            <Col md={3} />
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
